module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-patientform page-inner"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "form_patient"
  }, [_c('Header'), _c('div', {
    staticClass: "service-inner inner-container"
  }, [_c('div', {
    staticClass: "patient-section"
  }, [(_vm.props) ? _c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.title.rendered)
    }
  }) : _vm._e(), _c('hr'), (_vm.props) ? _c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.content.rendered)
    }
  }) : _vm._e()])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2183acea","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/thank-you/thank-you.pug
// module id = 535
// module chunks = 1